/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import RequestTypePie from './components/RequestTypePie';
import TabsList from './components/TabsList';
import Overview2 from './components/Overview2';
import DataSubject360Service from '../../services/DataSubject360.service';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { ROUTER } from '../../constants/router';
import { DateTime, Info } from 'luxon';

const { Option } = Select;
const date = new Date();
const currentYear = new Date().getFullYear();

export default function Dashboard() {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const navigate = useNavigate();

    const [selectPeriod, setSelectPeriod] = useState(currentYear);
    const [period, setPeriod] = useState('Yearly');
    const [tab, setTabs] = useState('1');
    const [requestList, setRequestList] = useState([]);
    const [pieGraphData, setPieGraphData] = useState([]);
    const [chartGraphData, setChartGraphData] = useState();
    const [keyword, setKeyword] = useState('');
    const [requestTypeId, setRequestTypeId] = useState('');
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        sortBy: 'requestDate',
        sortDirection: 'DESC',
        total: 0,
    });

    // Loading
    const [isLoadingPie, setIsLoadingPie] = useState(false);
    const [isLoadingGraph, setIsLoadingGraph] = useState(false);
    const [loading, setLoading] = useState(true);

    // Count
    const [newTotal, setNewTotal] = useState(0);
    const [verifiedTotal, setVerifiedTotal] = useState(0);
    const [preparingTotal, setPreparingTotal] = useState(0);
    const [inProgressTotal, setInProgressTotal] = useState(0);
    const [doneTotal, setDoneTotal] = useState(0);
    const [rejectTotal, setRejectTotal] = useState(0);
    const [archiveTotal, setArchiveTotal] = useState(0);
    const [allRequestTotal, setAllRequestTotal] = useState(0);

    const getYeasrList = () => {
        let listYears = [];
        for (let i = currentYear - 5; i < currentYear + 1; i++) {
            listYears.push(i);
        }
        return listYears.reverse();
    };

    const onSelectMonthChange = async (value) => {
        // console.log(value);
        setSelectPeriod(value);
        form.setFieldsValue({
            month: value,
        });
        await getChartGraph(period, value);
        await getPieGraph(period, value);
        setLoading(true);
    };
    const onSelectYearChange = async (value) => {
        // console.log(value);
        setSelectPeriod(value);
        form.setFieldsValue({
            year: value,
        });
        await getChartGraph(period, value);
        await getPieGraph(period, value);
        setLoading(true);
    };

    const getPieGraph = async (period, selectPeriod) => {
        const query = {
            period: period, //Last 7 Days,Monthly,Yearly
            month: period === 'Monthly' ? selectPeriod : currentMonth + 1, //1 = january
            year: period === 'Yearly' ? selectPeriod : currentYear,
        };
        setIsLoadingPie(true);
        try {
            const { data } = await DataSubject360Service.getPieGraph(query);
            const item = data?.resultData;
            setPieGraphData(item);
            setIsLoadingPie(false);
        } catch (error) {
            setIsLoadingPie(false);
            console.log('error', error);
        }
    };

    const findYealyName = (value) => {
        return DateTime.fromISO(value, {
            locale: i18n.language,
        }).toFormat('MMM');
    };

    const findDayName = (value) => {
        return DateTime.fromISO(value, {
            locale: i18n.language,
        }).toFormat('d MMM');
    };

    const getChartGraph = async (period, selectPeriod) => {
        const query = {
            period: period, //Last 7 Days,Monthly,Yearly
            month: period === 'Monthly' ? selectPeriod : currentMonth + 1, //1 = january
            year: period === 'Yearly' ? selectPeriod : currentYear,
        };
        setIsLoadingGraph(true);
        try {
            const { data } = await DataSubject360Service.getChartGraph(query);
            const item = data?.resultData;
            const formatItem = [];
            item?.forEach((element) => {
                formatItem.push({
                    date:
                        period === 'Last 7 Days'
                            ? findDayName(element.date)
                            : period === 'Monthly'
                            ? moment(element.date).format('D')
                            : period === 'Yearly'
                            ? findYealyName(element.date)
                            : null,
                    timeStamp: element.date,
                    value: element.value,
                });
            });
            setChartGraphData(formatItem);
            setIsLoadingGraph(false);
        } catch (error) {
            setIsLoadingGraph(false);
            console.log('error', error);
        }
    };

    const searchTable = async (
        period,
        selectPeriod,
        tab,
        keyword,
        requestTypeId,
        pageValue
    ) => {
        let reqStatus = '';
        setRequestList([]);
        if (tab === '1' || !tab) {
            reqStatus = 'New';
        } else if (tab === '2') {
            reqStatus = 'Verified';
        } else if (tab === '3') {
            reqStatus = 'Preparing';
        } else if (tab === '4') {
            reqStatus = 'In Progress';
        } else if (tab === '5') {
            reqStatus = 'Done';
        } else if (tab === '6') {
            reqStatus = 'Reject';
        } else if (tab === '7') {
            reqStatus = 'Archived';
        } else {
            reqStatus = null;
        }
        const query = {
            period: period, //Last 7 Days,Monthly,Yearly
            month: period === 'Monthly' ? selectPeriod : currentMonth + 1, //1 = january
            year: period === 'Yearly' ? selectPeriod : currentYear,
            keyword: keyword,
            requestTypeId: requestTypeId,
            requestStatus: reqStatus, //New, Verified, Preparing, In Progress, Done, Reject, Archived
            p: pageValue?.page ? pageValue?.page : 1,
            ps: pageValue?.pageSize ? pageValue?.pageSize : 10,
            s: pageValue?.sortBy ? pageValue?.sortBy : 'requestDate',
            sd: pageValue?.sortDirection ? pageValue?.sortDirection : 'DESC',
        };
        try {
            const { data } = await DataSubject360Service.searchList(query);
            const item = data?.resultData?.result;
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
            if (tab === '1') {
                setNewTotal(data?.resultData?.total);
            } else if (tab === '2') {
                setVerifiedTotal(data?.resultData?.total);
            } else if (tab === '3') {
                setPreparingTotal(data?.resultData?.total);
            } else if (tab === '4') {
                setInProgressTotal(data?.resultData?.total);
            } else if (tab === '5') {
                setDoneTotal(data?.resultData?.total);
            } else if (tab === '6') {
                setRejectTotal(data?.resultData?.total);
            } else if (tab === '7') {
                setArchiveTotal(data?.resultData?.total);
            } else {
                setAllRequestTotal(data?.resultData?.total);
            }
            setRequestList(item);
            setLoading(false);
        } catch (error) {
            console.log('error', error);
        }
    };

    const searchTotalTable = async (
        period,
        selectPeriod,
        tab,
        keyword,
        requestTypeId
    ) => {
        let reqStatus = '';
        if (tab === '1' || !tab) {
            reqStatus = 'New';
        } else if (tab === '2') {
            reqStatus = 'Verified';
        } else if (tab === '3') {
            reqStatus = 'Preparing';
        } else if (tab === '4') {
            reqStatus = 'In Progress';
        } else if (tab === '5') {
            reqStatus = 'Done';
        } else if (tab === '6') {
            reqStatus = 'Reject';
        } else if (tab === '7') {
            reqStatus = 'Archived';
        } else {
            reqStatus = null;
        }
        const query = {
            period: period, //Last 7 Days,Monthly,Yearly
            month: period === 'Monthly' ? selectPeriod : currentMonth + 1, //1 = january
            year: period === 'Yearly' ? selectPeriod : currentYear,
            keyword: keyword,
            requestTypeId: requestTypeId,
            requestStatus: reqStatus, //New, Verified, Preparing, In Progress, Done, Reject, Archived
            p: 1,
            ps: 10,
        };
        try {
            const { data } = await DataSubject360Service.searchList(query);
            if (tab === '1') {
                setNewTotal(data?.resultData?.total);
            } else if (tab === '2') {
                setVerifiedTotal(data?.resultData?.total);
            } else if (tab === '3') {
                setPreparingTotal(data?.resultData?.total);
            } else if (tab === '4') {
                setInProgressTotal(data?.resultData?.total);
            } else if (tab === '5') {
                setDoneTotal(data?.resultData?.total);
            } else if (tab === '6') {
                setRejectTotal(data?.resultData?.total);
            } else if (tab === '7') {
                setArchiveTotal(data?.resultData?.total);
            } else {
                setAllRequestTotal(data?.resultData?.total);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        if (loading) {
            searchTable(
                period,
                selectPeriod,
                tab,
                keyword,
                requestTypeId,
                currentPage
            );
        }
    }, [period, selectPeriod, tab, keyword, requestTypeId, loading]);

    useEffect(() => {
        getPieGraph(period, selectPeriod);
        getChartGraph(period, selectPeriod);
    }, [lang]);

    useEffect(() => {
        for (let i = 1; i <= 8; i++) {
            if (Number(tab) === i) {
                searchTable(
                    period,
                    selectPeriod,
                    String(i),
                    keyword,
                    requestTypeId
                );
            } else {
                searchTotalTable(period, selectPeriod, String(i), '', '');
            }
        }
    }, [period, selectPeriod]);

    const [lastTab, setLastTab] = useState();
    useEffect(() => {
        setLastTab(tab);
        for (let i = 1; i <= 8; i++) {
            if (Number(lastTab) === i) {
                searchTotalTable(period, selectPeriod, String(i), '', '');
            }
        }
    }, [tab]);

    const currentMonth = date.getMonth() + 1;
    const months = Info.months('long', { locale: i18n.language }).map(
        (month, index) => {
            return {
                key: index + 1,
                name: month,
            };
        }
    );

    return (
        <>
            <div className="title ">{t('common.Dashboard')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Data Subject 360')} /{' '}
                </span>
                <span> {t('Dashboard')}</span>
            </div>
            <div className="flex justify-between my-6 p-2 bg-white rounded-md">
                <div className="flex items-center space-x-2">
                    <span className="text-xl text-purple ml-2">
                        {t('Dashboard360.DashboardTitle')}
                    </span>
                    <span>
                        <button
                            type="button"
                            className="flex p-3 bg-[#F3F6F9] items-center justify-center rounded-lg text-purple"
                            onClick={() => {
                                navigate(`${ROUTER.DS_360.DASHBOARD}`);
                                const pageValue = {
                                    page: 1,
                                    pageSize: 10,
                                    sortBy: 'requestDate',
                                    sortDirection: 'DESC',
                                    total: 0,
                                };
                                setPeriod('Last 7 Days');
                                getPieGraph('Last 7 Days', selectPeriod);
                                getChartGraph('Last 7 Days', selectPeriod);
                                searchTable(
                                    'Last 7 Days',
                                    '',
                                    '1',
                                    '',
                                    '',
                                    pageValue
                                );
                                setTabs('1');
                            }}
                        >
                            <ReloadOutlined />
                        </button>
                    </span>
                </div>

                <div className="flex items-center cursor-pointer">
                    <Form form={form}>
                        <div className="px-2" hidden={period !== 'Monthly'}>
                            <Form.Item name="month" className="w-full mb-0">
                                <Select
                                    size="large"
                                    className="text-left text-[14px]"
                                    placeholder="Please Select"
                                    onChange={onSelectMonthChange}
                                    style={{ width: 140 }}
                                    defaultValue={date.getMonth()}
                                    value={selectPeriod}
                                >
                                    {months.map((month) => (
                                        <Option
                                            key={month.key}
                                            value={month.key}
                                        >
                                            {month.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="px-2" hidden={period !== 'Yearly'}>
                            <Form.Item name="year" className="w-full mb-0">
                                <Select
                                    size="large"
                                    className="text-left text-[14px]"
                                    placeholder="Please Select"
                                    onChange={onSelectYearChange}
                                    style={{ width: 140 }}
                                    defaultValue={currentYear}
                                    value={selectPeriod}
                                >
                                    {getYeasrList()?.map((year) => (
                                        <Option key={year} value={year}>
                                            {year}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </Form>

                    <button
                        type="button"
                        onClick={async () => {
                            setPeriod('Last 7 Days');
                            await getPieGraph('Last 7 Days', selectPeriod);
                            await getChartGraph('Last 7 Days', selectPeriod);
                        }}
                        className={
                            period === 'Last 7 Days'
                                ? `w-24 text-center p-1 rounded-l-xl bg-[#F3F5F8] text-[#7B67FB] text-[12px] font-semibold`
                                : `w-24 text-center p-1 rounded-l-xl bg-[#FFFFFF] text-[#171717] text-[12px]`
                        }
                        style={{
                            lineHeight: '32px',
                            borderStyle: 'solid',
                            borderColor:
                                period === 'Last 7 Days'
                                    ? '#F3F5F8'
                                    : '#E9EBF1',
                            borderWidth:
                                period === 'Last 7 Days'
                                    ? '1px 1px 1px 1px'
                                    : '1px 0px 1px 1px',
                        }}
                    >
                        {t('Dashboard360.Last7Days')}
                    </button>
                    <button
                        type="button"
                        onClick={async () => {
                            setPeriod('Monthly');
                            form.setFieldsValue({
                                month: currentMonth,
                            });
                            setSelectPeriod(currentMonth);
                            await getPieGraph('Monthly', currentMonth);
                            await getChartGraph('Monthly', currentMonth);
                        }}
                        className={
                            period === 'Monthly'
                                ? `w-24 text-center px-2 py-1 bg-[#F3F5F8] text-[#7B67FB] text-[12px] font-semibold`
                                : `w-24 text-center px-2 py-1 bg-[#FFFFFF] text-[#171717] text-[12px]`
                        }
                        style={{
                            lineHeight: '32px',
                            border:
                                period === 'Monthly'
                                    ? '1px solid #F3F5F8'
                                    : '1px solid #E9EBF1',
                        }}
                    >
                        {t('Dashboard360.Monthly')}
                    </button>
                    <button
                        type="button"
                        onClick={async () => {
                            setPeriod('Yearly');
                            form.setFieldsValue({
                                year: currentYear,
                            });
                            setSelectPeriod(currentYear);
                            await getPieGraph('Yearly', currentYear);
                            await getChartGraph('Yearly', currentYear);
                        }}
                        className={
                            period === 'Yearly'
                                ? `w-24 text-center px-2 py-1 bg-[#F3F5F8] text-[#7B67FB] rounded-r-xl text-[12px] font-semibold`
                                : `w-24 text-center px-2 py-1 bg-[#FFFFFF] text-[#171717] rounded-r-xl text-[12px]`
                        }
                        style={{
                            lineHeight: '32px',
                            borderStyle: 'solid',
                            borderColor:
                                period === 'Yearly' ? '#F3F5F8' : '#E9EBF1',
                            borderWidth:
                                period === 'Yearly'
                                    ? '1px 1px 1px 1px'
                                    : '1px 1px 1px 0px',
                        }}
                    >
                        {t('Dashboard360.Yearly')}
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-12 mt-4">
                <div className="flex items-center justify-center col-span-6 bg-white rounded-md mr-2">
                    <div className="p-6 w-full">
                        <RequestTypePie
                            isLoadingPie={isLoadingPie}
                            requestInfo={pieGraphData?.requestTypeList || []}
                            total={pieGraphData?.total}
                        />
                    </div>
                </div>
                <div className="col-span-6 bg-white rounded-md ml-2">
                    <div className="p-6">
                        <Overview2
                            isLoadingGraph={isLoadingGraph}
                            year={selectPeriod}
                            period={period}
                            selectPeriod={selectPeriod}
                            requestInfo={chartGraphData || []}
                        />
                    </div>
                </div>
                <div className="col-span-12 bg-white rounded-md mt-4">
                    <div className="p-6 ">
                        <TabsList
                            searchTable={searchTable}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setTabs={setTabs}
                            setLoading={setLoading}
                            tab={tab}
                            requestList={requestList}
                            newTotal={newTotal}
                            verifiedTotal={verifiedTotal}
                            preparingTotal={preparingTotal}
                            inProgressTotal={inProgressTotal}
                            doneTotal={doneTotal}
                            rejectTotal={rejectTotal}
                            archiveTotal={archiveTotal}
                            allRequestTotal={allRequestTotal}
                            setKeyword={setKeyword}
                            setRequestTypeId={setRequestTypeId}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
